import { 
    LOADING_SETTING, 
    POST_SETTING,
    SET_SETTING,
    SET_BANNER_LEFT,
    SET_BANNER_RIGHT_TOP,
    SET_BANNER_RIGHT_BOTTOM,
    DELETE_IMAGE_BANNER_LEFT,
    CLEAR_BANNER,
    GET_BANNER_LEFT,
    GET_BANNER_RIGHT_TOP,
    GET_BANNER_RIGHT_BOTTOM,
 } from '../types';

const initialState = {
    settings: [],
    banner_left: [],
    banner_right_top: '',
    banner_right_bottom: '',
    loading: false
}

export default function(state = initialState, action) {
    switch(action.type){
        case LOADING_SETTING:
            return {
                ...state,
                loading: true
            };
        case POST_SETTING:
            return {
                ...state,
                settings: [
                    action.payload,
                    ...state.settings
                ],
                banner_left: [],
                banner_right_top: '',
                banner_right_bottom: '',
            }
        case SET_BANNER_LEFT:
            state.banner_left.push({
                image: action.imageUrl
            })
            return {...state};
        case SET_BANNER_RIGHT_TOP:
            return {
                ...state,
                banner_right_top : {image: action.imageUrl},
            };
        case SET_BANNER_RIGHT_BOTTOM:
            return {
                ...state,
                banner_right_bottom: {image: action.imageUrl},
            };
        case SET_SETTING:
            state.settings.push(action.payload)
            return {
                ...state,
                loading: false
            }
        case DELETE_IMAGE_BANNER_LEFT:
            state.banner_left.splice(action.index, 1);
            return {...state};
        case CLEAR_BANNER:
            return {
                ...state,
                banner_left: [],
                banner_right_top: '',
                banner_right_bottom: '',
            }
        case GET_BANNER_LEFT:
                return {
                    ...state,
                    banner_left: action.payload,
                }
        case GET_BANNER_RIGHT_TOP:
            return {
                ...state,
                banner_right_top: action.payload,
            }
        case GET_BANNER_RIGHT_BOTTOM:
            return {
                ...state,
                banner_right_bottom: action.payload,
            }
        default:
            return state;
    }
}